// TODO: confirm final reason copy + ordering with @cfernandez @kperez

export const DISPATCH_DECLINE_REASONS = [
  { code: 'truck_unavailable', label: 'Truck unavailable' },
  { code: 'schedule_conflict', label: 'Schedule conflict' },
  { code: 'route_too_far', label: 'Route too far' },
  { code: 'pay_too_low', label: 'Pay too low' },
  { code: 'personal_emergency', label: 'Personal emergency' },
  { code: 'other', label: 'Other' },
] as const

export const DISPATCH_CANCEL_REASONS = [
  { code: 'contractor_cancellation', label: 'Contractor cancellation' },
  { code: 'truck_breakdown', label: 'Truck broken down' },
  { code: 'hazardous_work_conditions', label: 'Hazardous work conditions' },
  { code: 'other', label: 'Other' },
] as const

export const TICKET_REJECTION_REASONS = [
  { code: 'wrong_quantity', label: 'Wrong quantity' },
  { code: 'wrong_material', label: 'Wrong material' },
  { code: 'missing_attachment', label: 'Missing attachment' },
  { code: 'illegible_ticket', label: 'Illegible ticket' },
  { code: 'duplicate', label: 'Duplicate ticket' },
  { code: 'other', label: 'Other' },
] as const

export const TRIP_REJECTION_REASONS = [
  { code: 'missing_image' },
  { code: 'illegible_image' },
  { code: 'wrong_image' },
  { code: 'missing_paper_number' },
  { code: 'missing_data' },
  { code: 'other' },
] as const

export const DISPATCH_DECLINE_REASON_CODES = DISPATCH_DECLINE_REASONS.map((r) => r.code) as [
  (typeof DISPATCH_DECLINE_REASONS)[number]['code'],
  ...(typeof DISPATCH_DECLINE_REASONS)[number]['code'][],
]

export const DISPATCH_CANCEL_REASON_CODES = DISPATCH_CANCEL_REASONS.map((r) => r.code) as [
  (typeof DISPATCH_CANCEL_REASONS)[number]['code'],
  ...(typeof DISPATCH_CANCEL_REASONS)[number]['code'][],
]

export const TICKET_REJECTION_REASON_CODES = TICKET_REJECTION_REASONS.map((r) => r.code) as [
  (typeof TICKET_REJECTION_REASONS)[number]['code'],
  ...(typeof TICKET_REJECTION_REASONS)[number]['code'][],
]

export const TRIP_REJECTION_REASON_CODES = TRIP_REJECTION_REASONS.map((r) => r.code) as [
  (typeof TRIP_REJECTION_REASONS)[number]['code'],
  ...(typeof TRIP_REJECTION_REASONS)[number]['code'][],
]

export type DispatchDeclineReasonCode = (typeof DISPATCH_DECLINE_REASONS)[number]['code']
export type DispatchCancelReasonCode = (typeof DISPATCH_CANCEL_REASONS)[number]['code']
export type TicketRejectionReasonCode = (typeof TICKET_REJECTION_REASONS)[number]['code']
export type TripRejectionReasonCode = (typeof TRIP_REJECTION_REASONS)[number]['code']

export function getDispatchDeclineReasonLabel(code: string | null | undefined): string | null {
  if (!code) return null
  return DISPATCH_DECLINE_REASONS.find((r) => r.code === code)?.label ?? null
}

export function getDispatchCancelReasonLabel(code: string | null | undefined): string | null {
  if (!code) return null
  return DISPATCH_CANCEL_REASONS.find((r) => r.code === code)?.label ?? null
}

export function getTicketRejectionReasonLabel(code: string | null | undefined): string | null {
  if (!code) return null
  return TICKET_REJECTION_REASONS.find((r) => r.code === code)?.label ?? null
}
